import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { useState } from 'react'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'
import { AccountForm } from '@/widgets/account-form'

// Панель детали грузится на переходе — не тянем её в стартовый бандл.
const AccountDetail = lazyRouteComponent(() => import('@/widgets/account-detail'), 'AccountDetail')

export const Route = createFileRoute('/telephony/accounts/$accountId')({
  component: AccountPage,
})

function AccountPage() {
  const { accountId } = Route.useParams()
  const [editOpen, setEditOpen] = useState(false)

  return (
    <>
      <Breadcrumbs current={accountId} />
      <AccountDetail accountId={accountId} onEdit={() => setEditOpen(true)} />
      <AccountForm
        key={`${accountId}:${editOpen}`}
        open={editOpen}
        accountId={accountId}
        onClose={() => setEditOpen(false)}
      />
    </>
  )
}
